import actions from 'actions'
import { CALLOVER_LIST_VIEW_BY_GROUP } from 'constants/performance-page-constants'

const defaultState = {
  calloverListViewType: CALLOVER_LIST_VIEW_BY_GROUP,
  isSaving: false,
}

export default function performancePage(state = defaultState, action) {
  switch (action.type) {
    case actions.PERFORMANCE_SET_CALLOVER_LIST_VIEW_TYPE:
      return {
        ...state,
        calloverListViewType: action.viewType,
      }
    case actions.ENTITIES_DEALS.REQUEST :
      return {
        ...state,
        isSaving: true,
      }
    case actions.ENTITIES_DEALS.SUCCESS :
      return {
        ...state,
        isSaving: false,
      }
    case actions.ENTITIES_DEALS.FAILURE :
      return {
        ...state,
        isSaving: false,
      }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/pages/performance-page/performance-page.js
 **/